var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "motor-insurance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M13.4505 7.42886C15.6897 7.42886 15.9966 8.70607 16.1013 9.90347L16.227 11.0847C16.3685 12.4141 15.3265 13.5729 13.9897 13.5729H4.01026C2.67337 13.5729 1.63138 12.4141 1.7729 11.0847L1.89865 9.90347C2.01027 8.70607 2.31022 7.42886 4.54944 7.42886H13.4505Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55159 2.25C4.47282 2.25 3.94964 3.27909 3.69851 4.39767L3.43344 5.5546H2.72191C2.43591 5.5546 2.19873 5.77192 2.19873 6.03399C2.19873 6.29605 2.43591 6.51338 2.72191 6.51338H3.21719L2.92421 7.79175C3.3009 7.5936 3.82408 7.47216 4.54955 7.47216H13.4506C14.1761 7.47216 14.6993 7.5936 15.0759 7.79175L14.783 6.51338H15.2782C15.5642 6.51338 15.8014 6.29605 15.8014 6.03399C15.8014 5.77192 15.5642 5.5546 15.2782 5.5546H14.5667L14.3016 4.39767C14.0505 3.27909 13.5273 2.25 11.4486 2.25H6.55159Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90716 11.4201H4.81444C4.52843 11.4201 4.29126 11.1734 4.29126 10.8758C4.29126 10.5783 4.52843 10.3316 4.81444 10.3316H6.90716C7.19317 10.3316 7.43034 10.5783 7.43034 10.8758C7.43034 11.1734 7.19317 11.4201 6.90716 11.4201Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1855 11.4201H11.0928C10.8068 11.4201 10.5696 11.1734 10.5696 10.8758C10.5696 10.5783 10.8068 10.3316 11.0928 10.3316H13.1855C13.4715 10.3316 13.7087 10.5783 13.7087 10.8758C13.7087 11.1734 13.4715 11.4201 13.1855 11.4201Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5H14.25V14.625C14.25 15.2463 13.7463 15.75 13.125 15.75C12.5037 15.75 12 15.2463 12 14.625V13.5Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5H6V14.625C6 15.2463 5.49632 15.75 4.875 15.75C4.25368 15.75 3.75 15.2463 3.75 14.625V13.5Z",
    fill: "#6B47F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorInsurance);
export default __webpack_public_path__ + "static/media/motor-insurance.4c8c3f453631e52b3f16f4b8b58e87cd.svg";
export { ForwardRef as ReactComponent };